/** Marcador desde quien ganó (Eduardo 2026-10-06): el texto se GUARDA desde
 * el jugador 1 («4-6 7-5 TB 4-10»; standings y GG/GP lo leen así) pero se
 * MUESTRA siempre desde el ganador: si ganó el jugador 2 → «6-4 5-7 TB 10-4».
 * El tie-break entre paréntesis también se lee desde el ganador del partido:
 * «6-7(7-4)» → «6-7(4-7)» (perdió ese set 6-7 y el tie-break 4-7).
 *
 * Es SOLO presentación: no se usa para mandar ni para guardar. Su par en el
 * servidor es `score_text_from_winner` (backend/app/modules/matches/
 * score_utils.py); los dos pasan la tabla `scoreFromWinnerParityCases.json`. */

const SET_PATTERN = /(\d+)(\s*[-–:/]\s*)(\d+)(\s*\(\s*(\d+)(?:\s*[-–:/]\s*(\d+))?\s*\))?/g;

/** `winnerIsPlayer1`: true si ganó el jugador 1, false si el 2; null o
 * undefined (sin ganador) deja el texto tal cual. */
export function scoreTextFromWinner(
  scoreText: string | null | undefined,
  winnerIsPlayer1: boolean | null | undefined,
): string {
  const text = scoreText ?? "";
  if (!text.trim() || winnerIsPlayer1 == null) return text;
  return text.replace(
    SET_PATTERN,
    (_whole, g1: string, sep: string, g3: string, paren: string | undefined, t1: string | undefined, t2: string | undefined) => {
      const first = winnerIsPlayer1 ? g1 : g3;
      const second = winnerIsPlayer1 ? g3 : g1;
      let tiebreak = "";
      if (paren !== undefined) {
        if (t2 === undefined) {
          tiebreak = `(${t1})`;
        } else {
          const hi = Math.max(Number(t1), Number(t2));
          const lo = Math.min(Number(t1), Number(t2));
          const a = Number(first);
          const b = Number(second);
          tiebreak = a > b ? `(${hi}-${lo})` : a < b ? `(${lo}-${hi})` : `(${t1}-${t2})`;
        }
      }
      return `${first}${sep}${second}${tiebreak}`;
    },
  );
}

interface MatchLikeForScore {
  score_text?: string | null;
  winner_participant_id?: number | null;
  player1_participant_id?: number | null;
  player2_participant_id?: number | null;
  player1?: { id?: number | null } | null;
  player2?: { id?: number | null } | null;
}

/** ¿Ganó el jugador 1? null si no hay ganador o no se puede saber. */
export function winnerIsPlayer1(match: MatchLikeForScore): boolean | null {
  const winner = match.winner_participant_id;
  if (winner == null) return null;
  const p1 = match.player1_participant_id ?? match.player1?.id ?? null;
  const p2 = match.player2_participant_id ?? match.player2?.id ?? null;
  if (p1 != null && winner === p1) return true;
  if (p2 != null && winner === p2) return false;
  return null;
}

/** Marcador de un partido (o reporte) desde quien ganó. */
export function matchScoreFromWinner(match: MatchLikeForScore | null | undefined): string {
  if (!match) return "";
  return scoreTextFromWinner(match.score_text, winnerIsPlayer1(match));
}
